module.exports = __webpack_public_path__ + "img/service-options-swoop-cjdr.9025c392.jpg";